/* Collection UI only. Product prices, inventory and cart requests remain Shopify-owned. */
(() => {
  'use strict';
  if (window.__vvCollectionGlass) return;
  window.__vvCollectionGlass = true;
  let activeDialog = null;
  let opener = null;
  let savedOverflow = '';
  let closeTimer;
  let savedRootOverflow = '';
  const root = document.documentElement;
  const setLayout = (value, persist = true) => {
    const list = value === 'list';
    root.classList.toggle('vv-list-view', list);
    document.querySelectorAll('[data-vv-layout]').forEach(button => {
      const selected = button.dataset.vvLayout === (list ? 'list' : 'grid');
      button.classList.toggle('is-active', selected);
      button.setAttribute('aria-pressed', String(selected));
    });
    if (persist) { try { sessionStorage.setItem('viviland.collection.layout', list ? 'list' : 'grid'); } catch (_) {} }
  };
  const restore = () => {
    clearTimeout(closeTimer);
    document.body.style.overflow = savedOverflow;
    root.style.overflow = savedRootOverflow;
    if (activeDialog) activeDialog.classList.remove('is-open');
    if (opener && opener.isConnected) { opener.setAttribute('aria-expanded', 'false'); opener.focus({preventScroll: true}); }
    activeDialog = null;
  };
  const close = () => {
    if (!activeDialog) return;
    const dialog = activeDialog;
    dialog.classList.remove('is-open');
    clearTimeout(closeTimer);
    const finish = () => { if (typeof dialog.close === 'function') dialog.close(); else { dialog.removeAttribute('open'); restore(); } };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else closeTimer = setTimeout(finish, 220);
  };
  const init = () => {
    try { setLayout(sessionStorage.getItem('viviland.collection.layout'), false); } catch (_) { setLayout('grid', false); }
    document.querySelectorAll('.vv-dialog').forEach(dialog => {
      if (dialog.dataset.vvReady) return;
      dialog.dataset.vvReady = 'true';
      dialog.addEventListener('close', restore);
      dialog.addEventListener('cancel', event => {event.preventDefault(); close();});
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
      });
    });
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-vv-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.vvOpen);
      if (!dialog || dialog.open) return;
      if (activeDialog) return;
      opener = trigger;
      activeDialog = dialog;
      savedOverflow = document.body.style.overflow;
      savedRootOverflow = root.style.overflow;
      root.style.overflow = 'hidden';
      dialog.querySelectorAll('input[type=number]').forEach(input => { input.disabled = false; });
      updateFilters(dialog.querySelector('.vv-filter-form'));
      positionFilter(dialog);
      document.body.style.overflow = 'hidden';
      trigger.setAttribute('aria-expanded', 'true');
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      dialog.getBoundingClientRect();
      requestAnimationFrame(() => { if (dialog.open) dialog.classList.add('is-open'); });
      const first = dialog.querySelector('button, input, select, a[href]');
      first?.focus({preventScroll: true});
      return;
    }
    const clearFilters = event.target.closest('[data-vv-filter-clear]');
    if (clearFilters) {
      const form = clearFilters.closest('form');
      form.querySelectorAll('input[type=checkbox]').forEach(input => { input.checked = false; });
      form.querySelectorAll('input[type=number]').forEach(input => { input.value = ''; input.disabled = false; });
      updateFilters(form);
      return;
    }
    if (event.target.closest('[data-vv-close]')) { close(); return; }
    const layout = event.target.closest('[data-vv-layout]');
    if (layout) { setLayout(layout.dataset.vvLayout); return; }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      if (activeDialog) { event.preventDefault(); close(); }
    }
  });
  function updateFilters(form) {
    if (!form) return true;
    let total = 0;
    form.querySelectorAll('.vv-filter-group').forEach(group => {
      const count = group.querySelectorAll('input[type=checkbox]:checked').length + (Array.from(group.querySelectorAll('input[type=number]')).some(input => input.value !== '') ? 1 : 0);
      const badge = group.querySelector('[data-vv-filter-selected]');
      badge.textContent = count; badge.hidden = !count; total += count;
    });
    const totalBadge = form.querySelector('[data-vv-filter-total]');
    totalBadge.textContent = total; totalBadge.hidden = !total;
    const min = form.querySelector('#vv-price-min');
    const max = form.querySelector('#vv-price-max');
    const error = form.querySelector('#vv-price-error');
    const reversed = min && max && min.value !== '' && max.value !== '' && Number(min.value) > Number(max.value);
    if (error) error.hidden = !reversed;
    for (const input of [min,max]) {
      if (!input) continue;
      input.setCustomValidity(reversed ? error.textContent : '');
      if (reversed) input.setAttribute('aria-invalid','true'); else input.removeAttribute('aria-invalid');
    }
    return !reversed;
  }
  function positionFilter(dialog = activeDialog) {
    if (!dialog) return;
    const viewport = window.visualViewport;
    dialog.style.setProperty('--vv-filter-viewport-height',`${viewport?.height || innerHeight}px`);
    // Keep the panel centered in the visible viewport, including a mobile keyboard.
    dialog.style.top = `${viewport?.offsetTop || 0}px`;
    dialog.style.bottom = `${Math.max(0,innerHeight - (viewport?.height || innerHeight) - (viewport?.offsetTop || 0))}px`;
  }
  window.visualViewport?.addEventListener('resize', () => positionFilter());
  window.visualViewport?.addEventListener('scroll', () => positionFilter());
  window.addEventListener('resize', () => positionFilter());
  document.addEventListener('input', event => {
    const form = event.target.closest?.('.vv-filter-form');
    if (form) updateFilters(form);
  });
  document.addEventListener('change', event => {
    const form = event.target.closest?.('.vv-filter-form');
    if (form) updateFilters(form);
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('vv-filter-form')) return;
    if (!updateFilters(form)) { event.preventDefault(); form.reportValidity(); return; }
    /* Do not send blank price bounds, and do not preserve an obsolete pagination cursor. */
    form.querySelectorAll('input[type="number"]').forEach(input => { input.disabled = input.value.trim() === ''; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true}); else init();
  document.addEventListener('shopify:section:load', init);
})();


(() => {
  let frame = 0;
  const update = () => {
    frame = 0;
    const button = document.querySelector('[data-vv-back-to-top]');
    if (button) button.hidden = window.scrollY < Math.max(320, window.innerHeight * .6);
  };
  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };
  window.addEventListener('scroll', schedule, {passive: true});
  window.addEventListener('resize', schedule, {passive: true});
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-vv-back-to-top]')) return;
    document.querySelector('.vv-wordmark')?.focus({preventScroll: true});
    window.scrollTo({top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  });
  update();
})();

/* Homepage popup interactions, adapted to the collection header geometry. */
(() => {
  if (!document.querySelector('[data-vv-bag]')) return;
  const on = (target, type, handler) => target?.addEventListener(type, handler);
    const menu = document.querySelector('#vv-menu-dialog');
    const trigger = document.querySelector('.vv-menu-toggle');
    const header = document.querySelector('.vv-header');
    const search = document.querySelector('#search-dialog');
    const searchTrigger = document.querySelector('[data-search]');
    const bag = document.querySelector('#bag-dialog');
    const bagTrigger = document.querySelector('[data-vv-bag]');
    menu.querySelectorAll('a[href^="#"]').forEach(link => { link.href = `${bag.dataset.rootUrl}${link.getAttribute('href')}`; });
    let bagRequest;
    let bagRequestId = 0;
    let bagMutation = null;
    let scrollState;
    const headerSection = header.closest('.vv-header-section');
    function lockScroll() {
      if (scrollState) return;
      scrollState = { y: scrollY, body: {}, overflow: document.documentElement.style.overflow, header: Object.fromEntries(['position','top','left','width','margin'].map(key => [key, header.style[key]])) };
      for (const key of ['position', 'top', 'left', 'right', 'width', 'overflow']) scrollState.body[key] = document.body.style[key];
      scrollState.sectionHeight = headerSection.style.height;
      headerSection.style.height = `${headerSection.offsetHeight}px`;
      const rect = header.getBoundingClientRect();
      Object.assign(header.style, { position: 'fixed', top: `${rect.top}px`, left: `${rect.left}px`, width: `${rect.width}px`, margin: '0' });
      Object.assign(document.body.style, { position: 'fixed', top: `-${scrollState.y}px`, left: '0', right: '0', width: '100%', overflow: 'hidden' });
      document.documentElement.style.overflow = 'hidden';
    }
    function unlockScroll() {
      if (!scrollState) return;
      const state = scrollState;
      scrollState = null;
      const old = document.documentElement.style.scrollBehavior;
      document.documentElement.style.scrollBehavior = 'auto';
      Object.assign(document.body.style, state.body);
      Object.assign(header.style, state.header);
      headerSection.style.height = state.sectionHeight;
      document.documentElement.style.overflow = state.overflow;
      window.scrollTo(0, state.y);
      document.documentElement.style.scrollBehavior = old;
    }
    function closeMenu() {
      menu?.classList.remove('is-open');
      menu?.close();
      trigger?.setAttribute('aria-expanded', 'false');
      unlockScroll();
    }
    function positionMenu() {
      const headerBottom = header.getBoundingClientRect().bottom;
      menu.style.top = `${headerBottom + 8}px`;
      menu.style.maxHeight = `${Math.max(100, innerHeight - headerBottom - 24)}px`;
    }
    const menuPanels = [...(menu?.querySelectorAll('[data-menu-panel]') || [])];
    const menuScroll = menu?.querySelector('[data-menu-scroll]');
    const menuPositions = new Map();
    function showMenuPanel(id, returning = false, focus = true) {
      const panel = menuPanels.find(item => item.id === id);
      if (!panel) return;
      const previous = menuPanels.find(item => !item.hidden);
      if (previous) menuPositions.set(previous.id, menuScroll.scrollTop);
      menuPanels.forEach(item => { item.hidden = item !== panel; });
      menu.querySelectorAll('[data-menu-next]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.menuNext === id)));
      menuScroll.scrollTop = returning ? menuPositions.get(id) || 0 : 0;
      if (focus) {
        const target = returning ? [...panel.querySelectorAll('[data-menu-next]')].find(button => button.dataset.menuNext === previous?.id) : panel.querySelector('.home-menu-title');
        (target || panel.querySelector('button, a'))?.focus({ preventScroll: true });
      }
    }
    on(trigger, 'click', () => {
      if (menu.open) return;
      menuPositions.clear();
      showMenuPanel('home-menu-root', false, false);
      lockScroll();
      menu.showModal();
      positionMenu();
      trigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => menu.classList.add('is-open'));
    });
    on(menu?.querySelector('.menu-close'), 'click', closeMenu);
    on(menu, 'cancel', event => { event.preventDefault(); closeMenu(); });
    on(menu, 'close', () => { unlockScroll(); trigger?.setAttribute('aria-expanded', 'false'); });
    on(menu, 'click', event => {
      const next = event.target.closest('[data-menu-next]');
      if (next) { showMenuPanel(next.dataset.menuNext); return; }
      const back = event.target.closest('[data-menu-back]');
      if (back) { showMenuPanel(back.dataset.menuBack, true); return; }
      if (event.target.closest('a[href]')) { closeMenu(); return; }
      if (event.target === menu) {
        const box = menu.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeMenu();
      }
    });
    on(window, 'resize', () => {
      if (!menu?.open) return;
      if (innerWidth > 1023) closeMenu();
      else positionMenu();
    });
    const desktopMenus = [...header.querySelectorAll('[data-home-desktop]')];
    header.querySelectorAll('.home-desktop-nav > a').forEach(link => {
      if (link.pathname === location.pathname) link.setAttribute('aria-current', 'page');
    });
    header.querySelectorAll('.home-desktop-branch').forEach(branch => {
      if (branch.querySelector('[aria-current="page"]')) branch.open = true;
      const summary = branch.querySelector(':scope > summary');
      const sync = () => summary?.setAttribute('aria-expanded', String(branch.open));
      sync();
      on(branch, 'toggle', sync);
    });
    desktopMenus.forEach(details => {
      const summary = details.querySelector(':scope > summary');
      summary?.setAttribute('aria-expanded', String(details.open));
      on(details, 'toggle', () => {
        summary?.setAttribute('aria-expanded', String(details.open));
        if (details.open) desktopMenus.forEach(other => { if (other !== details) other.open = false; });
      });
      on(details, 'keydown', event => {
        if (event.key !== 'Escape') return;
        const branch = event.target.closest('details[open]');
        if (branch?.open) { event.preventDefault(); event.stopPropagation(); branch.open = false; branch.querySelector('summary')?.focus(); }
      });
      on(details, 'focusout', event => { if (event.relatedTarget && !details.contains(event.relatedTarget)) details.open = false; });
    });
    on(document, 'click', event => { desktopMenus.forEach(details => { if (!details.contains(event.target)) details.open = false; }); });
    on(window, 'resize', () => {
      if (innerWidth <= 1023) desktopMenus.forEach(details => { details.open = false; });
    });
    on(searchTrigger, 'click', () => { lockScroll(); search.showModal(); search.querySelector('input[type="search"]').focus(); });
    on(search?.querySelector('[data-close-search]'), 'click', () => search.close());
    on(search, 'close', () => { unlockScroll(); searchTrigger?.focus(); });
    function positionBag() {
      const rect = bagTrigger.getBoundingClientRect();
      const top = Math.max(16, Math.min(Math.max(rect.bottom + 14, header.getBoundingClientRect().bottom + 8), innerHeight - 260));
      const right = Math.max(16, Math.min(innerWidth - rect.right, innerWidth - bag.offsetWidth - 16));
      bag.style.top = `${top}px`;
      bag.style.right = `${right}px`;
      bag.style.maxHeight = `${Math.max(180, innerHeight - top - 16)}px`;
      bag.style.setProperty('--bag-origin-x', `${bag.offsetWidth - rect.width / 2}px`);
      bag.style.setProperty('--bag-origin-y', `${rect.top - top}px`);
    }
    function groupBagLines(body) {
      // Automatic promotions can split one variant into several Shopify lines.
      // Keep their real keys for edits; only combine identical purchase options.
      const groups = new Map();
      for (const row of body.querySelectorAll('.bag-item')) {
        const meta = row.querySelector('[data-bag-line-meta]');
        if (!meta || row.dataset.gift === 'true') continue;
        const properties = JSON.parse(meta.dataset.properties || '{}') || {};
        const signature = JSON.stringify([meta.dataset.variant, meta.dataset.plan,
          Object.entries(properties).sort(([a], [b]) => a.localeCompare(b))]);
        const lines = groups.get(signature) || [];
        lines.push({ row, key: row.dataset.lineKey, quantity: Number(row.dataset.quantity),
          original: Number(meta.dataset.original), final: Number(meta.dataset.final) });
        groups.set(signature, lines);
      }
      for (const lines of groups.values()) {
        if (lines.length < 2) continue;
        const row = lines[0].row;
        const quantity = lines.reduce((sum, line) => sum + line.quantity, 0);
        row.dataset.quantity = String(quantity);
        row.dataset.lines = JSON.stringify(lines.map(({key, quantity}) => ({key, quantity})));
        row.querySelector('.bag-quantity-value').textContent = String(quantity);
        row.querySelector('[data-bag-edit="decrease"]').disabled = quantity <= Number(row.dataset.min || 1);
        row.querySelector('[data-bag-edit="increase"]').disabled = !!row.dataset.max && quantity >= Number(row.dataset.max);
        const original = lines.reduce((sum, line) => sum + line.original, 0);
        const final = lines.reduce((sum, line) => sum + line.final, 0);
        const money = amount => `${new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: body.dataset.currency, currencyDisplay: 'narrowSymbol'
        }).format(amount / 100)} ${body.dataset.currency}`;
        const price = row.querySelector('.bag-item-price');
        price.replaceChildren();
        if (original > final) {
          const before = document.createElement('s'); before.textContent = money(original);
          price.append(before, ' ');
        }
        const after = document.createElement('strong'); after.textContent = money(final); price.append(after);
        const discounts = new Set([...row.querySelectorAll('.bag-discount')].map(node => node.textContent));
        for (const line of lines.slice(1)) {
          for (const discount of line.row.querySelectorAll('.bag-discount')) {
            if (!discounts.has(discount.textContent)) {
              discounts.add(discount.textContent); row.querySelector('.bag-item-info').append(discount);
            }
          }
          line.row.remove();
        }
      }
    }
    function renderBag(htmlText, focusState) {
      const html = new DOMParser().parseFromString(htmlText, 'text/html');
      const fresh = html.querySelector('#bag-dialog .bag-body');
      if (!fresh || !/^\d+$/.test(fresh.dataset.itemCount)) throw new Error('Cart section missing');
      groupBagLines(fresh);
      const explore = fresh.querySelector('[data-bag-collections]');
      if (explore) explore.href = `${bag.dataset.rootUrl}#collections`;
      bag.querySelector('.bag-body').replaceWith(document.importNode(fresh, true));
      bag.querySelector('[data-bag-count]').textContent = `(${fresh.dataset.itemCount})`;
      const badge = bagTrigger.querySelector('[data-header-bag-count]');
      bagTrigger.setAttribute('aria-label', `${bag.querySelector('#bag-title').childNodes[0].textContent.trim()} (${fresh.dataset.itemCount})`);
      if (badge) { badge.textContent = fresh.dataset.itemCount; badge.hidden = Number(fresh.dataset.itemCount) === 0; }
      bag.querySelector('.bag-status').hidden = true;
      bag.querySelector('.bag-fallback').hidden = true;
      bag.dataset.ready = 'true';
      if (focusState) {
        const content = bag.querySelector('.bag-content');
        if (content) content.scrollTop = focusState.scroll;
        const rows = [...bag.querySelectorAll('.bag-item')];
        const row = rows[Math.min(focusState.index, rows.length - 1)];
        const target = row?.querySelector(`[data-bag-edit="${focusState.action}"]:not(:disabled)`) || row?.querySelector('.bag-remove') || bag.querySelector('.bag-close');
        target?.focus({ preventScroll: true });
      }
    }
    async function refreshBag(focusState, allowGiftCleanup = false) {
      bagRequest?.abort();
      const requestId = ++bagRequestId;
      const request = new AbortController();
      bagRequest = request;
      const timer = setTimeout(() => request.abort(), 10000);
      const status = bag.querySelector('.bag-status');
      const body = bag.querySelector('.bag-body');
      const fallback = bag.querySelector('.bag-fallback');
      status.textContent = bag.dataset.loading;
      status.classList.remove('is-error');
      status.hidden = false;
      body.hidden = true;
      fallback.hidden = true;
      bag.setAttribute('aria-busy', 'true');
      bag.dataset.ready = 'false';
      try {
        const url = new URL(bag.dataset.rootUrl, location.origin);
        url.searchParams.set('section_id', bag.dataset.sectionId);
        const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', signal: request.signal });
        if (!response.ok) throw new Error('Cart section unavailable');
        const htmlText = await response.text();
        if (requestId !== bagRequestId || !bag.open) return;
        renderBag(htmlText, focusState);
        if (allowGiftCleanup && !bagMutation && !bag.querySelector('.bag-item[data-qualifier="true"]')) {
          const orphan = bag.querySelector('.bag-item[data-gift="true"] [data-bag-edit="remove"]');
          if (orphan) changeBagItem(orphan);
        }
        return true;
      } catch {
        if (requestId !== bagRequestId || !bag.open) return;
        status.textContent = bag.dataset.error;
        fallback.hidden = false;
        return false;
      } finally {
        clearTimeout(timer);
        if (requestId === bagRequestId && !bagMutation) bag.removeAttribute('aria-busy');
      }
    }
    function changeBagItem(button) {
      if (bagMutation || bag.dataset.ready !== 'true' || button.disabled) return;
      const row = button.closest('.bag-item');
      if (!row || !row.dataset.lineKey) return;
      const action = button.dataset.bagEdit;
      if (!['increase', 'decrease', 'remove'].includes(action)) return;
      if (row.dataset.gift === 'true' && action !== 'remove') return;
      const currentQuantity = Number(row.dataset.quantity);
      const step = Number(row.dataset.step || 1);
      const quantity = action === 'remove' ? 0 : currentQuantity + (action === 'increase' ? step : -step);
      if (!Number.isInteger(quantity) || quantity < 0 || (action !== 'remove' && (quantity < Number(row.dataset.min || 1) || (row.dataset.max && quantity > Number(row.dataset.max))))) return;
      const lines = row.dataset.lines ? JSON.parse(row.dataset.lines) : [{key: row.dataset.lineKey, quantity: currentQuantity}];
      let endpoint = bag.dataset.changeUrl;
      let payload;
      if (lines.length === 1) payload = {id: lines[0].key, quantity};
      else if (action === 'increase') {
        const line = lines.at(-1);
        payload = {id: line.key, quantity: line.quantity + step};
      } else {
        // A bulk request is only used to decrease/remove, never to bypass stock checks.
        let remaining = currentQuantity - quantity;
        const updates = {};
        for (const line of [...lines].reverse()) {
          const remove = Math.min(line.quantity, remaining);
          if (remove) updates[line.key] = line.quantity - remove;
          remaining -= remove;
        }
        const changed = Object.entries(updates);
        if (changed.length === 1) payload = {id: changed[0][0], quantity: changed[0][1]};
        else { endpoint = bag.querySelector('.bag-body').dataset.updateUrl; payload = {updates}; }
      }
      if (action === 'remove') {
        const remainingQualifier = [...bag.querySelectorAll('.bag-item[data-qualifier="true"]')].some(item => item !== row);
        if (!remainingQualifier) {
          const gifts = [...bag.querySelectorAll('.bag-item[data-gift="true"]')];
          if (gifts.length) {
            const updates = payload.updates || { [payload.id]: 0 };
            for (const gift of gifts) updates[gift.dataset.lineKey] = 0;
            if (Object.keys(updates).length > 1) {
              endpoint = bag.querySelector('.bag-body').dataset.updateUrl;
              payload = {updates};
            }
          }
        }
      }
      const focusState = { index: [...bag.querySelectorAll('.bag-item')].indexOf(row), action, scroll: bag.querySelector('.bag-content')?.scrollTop || 0 };
      bag.dataset.ready = 'false';
      bag.dataset.changing = 'true';
      bag.setAttribute('aria-busy', 'true');
      bag.querySelector('.bag-body').inert = true;
      const status = bag.querySelector('.bag-status');
      status.classList.remove('is-error');
      status.textContent = bag.dataset.loading;
      status.hidden = false;
      const operation = async () => {
        const request = new AbortController();
        const timer = setTimeout(() => request.abort(), 15000);
        let failure = '';
        try {
          const response = await fetch(endpoint, {
            method: 'POST', credentials: 'same-origin', signal: request.signal,
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ ...payload, sections: [bag.dataset.sectionId], sections_url: bag.dataset.rootUrl })
          });
          const data = await response.json();
          if (!response.ok || data.status >= 400) {
            failure = typeof data.description === 'string' ? data.description : bag.dataset.error;
          } else if (bag.open) {
            const sectionHtml = data.sections?.[bag.dataset.sectionId];
            if (sectionHtml) {
              try { renderBag(sectionHtml, focusState); return; } catch { /* Re-read if only section rendering failed. */ }
            }
          } else return;
        } catch { failure = bag.dataset.error; }
        finally { clearTimeout(timer); }
        // Never repeat a mutation after an uncertain response; reconcile with a read.
        if (bag.open) {
          const refreshed = await refreshBag(focusState, false);
          if (failure && refreshed) { status.textContent = failure; status.classList.add('is-error'); status.hidden = false; }
        }
      };
      bagMutation = operation().finally(() => {
        bagMutation = null;
        bag.dataset.changing = 'false';
        bag.removeAttribute('aria-busy');
        const body = bag.querySelector('.bag-body');
        if (body) body.inert = false;
      });
    }
    function closeBag() {
      bagRequestId++;
      bagRequest?.abort();
      bag?.classList.remove('is-open');
      bag?.close();
      bagTrigger?.setAttribute('aria-expanded', 'false');
      unlockScroll();
    }
    on(bagTrigger, 'click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      if (bag.open) return;
      lockScroll();
      bag.showModal();
      positionBag();
      bagTrigger.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(() => { if (bag.open) bag.classList.add('is-open'); });
      if (bagMutation) {
        bag.querySelector('.bag-body').hidden = true;
        bag.querySelector('.bag-status').hidden = false;
        bagMutation.then(() => { if (bag.open) refreshBag(); });
      } else refreshBag();
    });
    on(bag?.querySelector('.bag-close'), 'click', closeBag);
    on(bag, 'cancel', event => { event.preventDefault(); closeBag(); });
    on(bag, 'close', () => { unlockScroll(); bagTrigger?.setAttribute('aria-expanded', 'false'); });
    on(bag, 'submit', event => { if (bag.dataset.ready !== 'true') event.preventDefault(); });
    on(bag, 'click', event => {
      const edit = event.target.closest('[data-bag-edit]');
      if (edit) { changeBagItem(edit); return; }
      if (event.target.closest('[data-bag-collections]')) closeBag();
      if (event.target !== bag) return;
      const rect = bag.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeBag();
    });
    on(window, 'resize', () => { if (bag?.open) positionBag(); });

    for (const dialog of [menu, search, bag]) on(dialog, 'keydown', event => {
      if (event.key !== 'Tab') return;
      const items = [...dialog.querySelectorAll('button, a[href]:not([tabindex="-1"]), input:not([type="hidden"]), [tabindex="0"]')].filter(item => !item.disabled && item.getClientRects().length > 0);
      if (event.shiftKey && document.activeElement === items[0]) { event.preventDefault(); items.at(-1)?.focus(); }
      else if (!event.shiftKey && document.activeElement === items.at(-1)) { event.preventDefault(); items[0]?.focus(); }
    });

    on(window, 'pagehide', () => { closeMenu(); closeBag(); unlockScroll(); });
})();

/* Progressive enhancement: the original select still owns the submitted sort_by value. */
(() => {
  function initSort() {
    const select = document.querySelector('#vv-sort-by');
    const trigger = document.querySelector('#vv-sort-trigger');
    if (!select || !trigger || trigger.dataset.ready) return;
    const wrapper = trigger.closest('.vv-select-wrap');
    const custom = trigger.closest('.vv-sort-custom');
    const list = custom.querySelector('[role=listbox]');
    const value = trigger.querySelector('#vv-sort-value');
    const fields = trigger.closest('.vv-filter-fields');
    const dialog = trigger.closest('dialog');
    let current = select.selectedIndex, opened = false, buffer = '', typingTimer;
    const items = Array.from(select.options).map((option,index) => {
      const item = document.createElement('div');
      item.className = 'vv-sort-option'; item.id = `vv-sort-option-${index}`;
      item.setAttribute('role','option'); item.setAttribute('aria-selected',String(option.selected));
      item.dataset.index = index;
      const label = document.createElement('span'); label.textContent = option.textContent;
      item.append(label);
      const icon = document.createElementNS('http://www.w3.org/2000/svg','svg');
      for (const [name,val] of Object.entries({viewBox:'0 0 24 24',width:'16',height:'16',fill:'none',stroke:'currentColor','stroke-width':'1.7','aria-hidden':'true'})) icon.setAttribute(name,val);
      const path = document.createElementNS('http://www.w3.org/2000/svg','path');path.setAttribute('d','m5 12 4 4L19 6');icon.append(path);item.append(icon);
      list.append(item); return item;
    });
    const sync = () => {
      value.textContent = select.options[select.selectedIndex]?.textContent || '';
      items.forEach((item,index) => item.setAttribute('aria-selected',String(index === select.selectedIndex)));
    };
    const close = () => {
      opened = false; list.hidden = true; trigger.setAttribute('aria-expanded','false');trigger.removeAttribute('aria-activedescendant');
      clearTimeout(typingTimer);buffer='';
    };
    const position = () => {
      const available = fields.getBoundingClientRect().bottom - trigger.getBoundingClientRect().bottom - 10;
      list.style.maxHeight = `${Math.max(44,Math.min(244,available))}px`;
    };
    const highlight = index => {
      current = Math.max(0,Math.min(items.length-1,index));
      items.forEach((item,i) => item.classList.toggle('is-active',i===current));
      trigger.setAttribute('aria-activedescendant',items[current].id);
      const item = items[current];
      const top = item.offsetTop, bottom = top + item.offsetHeight;
      if (top < list.scrollTop) list.scrollTop = top;
      else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight;
    };
    const open = () => {
      if (!items.length) return;
      opened = true;list.hidden=false;trigger.setAttribute('aria-expanded','true');position();highlight(select.selectedIndex);
    };
    const choose = index => {
      select.value=select.options[index].value;sync();close();trigger.focus({preventScroll:true});
      select.dispatchEvent(new Event('change',{bubbles:true}));
    };
    trigger.addEventListener('click', () => opened ? close() : open());
    list.addEventListener('mousedown',event=>event.preventDefault());
    list.addEventListener('click',event=>{const item=event.target.closest('[role=option]');if(item)choose(Number(item.dataset.index));});
    trigger.addEventListener('keydown',event=>{
      if (event.key==='Escape' && opened) {event.preventDefault();event.stopPropagation();close();return;}
      if (event.key==='Tab') {close();return;}
      if (event.key==='Enter' || event.key===' ') {event.preventDefault();if(opened)choose(current);else open();return;}
      if (['ArrowDown','ArrowUp','Home','End'].includes(event.key)) {
        event.preventDefault();const wasOpen=opened;if(!opened)open();
        if(event.key==='Home')highlight(0);else if(event.key==='End')highlight(items.length-1);
        else if(wasOpen)highlight(current+(event.key==='ArrowDown'?1:-1));
        return;
      }
      if(event.key.length===1 && !event.ctrlKey && !event.metaKey && !event.altKey){
        event.preventDefault();if(!opened)open();buffer+=event.key.toLowerCase();clearTimeout(typingTimer);typingTimer=setTimeout(()=>{buffer='';},650);
        const index=Array.from(select.options).findIndex(option=>option.textContent.toLowerCase().startsWith(buffer));if(index>=0)highlight(index);
      }
    });
    document.addEventListener('click',event=>{if(opened && !wrapper.contains(event.target))close();});
    custom.addEventListener('focusout',event=>{if(!custom.contains(event.relatedTarget))close();});
    dialog.addEventListener('close',close);
    fields.addEventListener('scroll',close,{passive:true});
    window.addEventListener('resize',()=>{if(opened)position();});
    window.visualViewport?.addEventListener('resize',()=>{if(opened)position();});
    select.addEventListener('change',sync);
    sync();select.hidden=true;wrapper.querySelector(':scope > svg').setAttribute('hidden','');
    document.querySelector('#vv-sort-label').htmlFor=trigger.id;
    custom.hidden=false;trigger.dataset.ready='true';
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initSort,{once:true});else initSort();
  document.addEventListener('shopify:section:load',initSort);
})();
